export default __webpack_public_path__ + "images/5b927ea18cb6a1b44717a76442eab57e.jpg";